import React from "react";
import { formatPrice } from "~/utils/number-format";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { UserCommission } from "~/types/api/dex/rebate";

const InviteCard: React.FC<{ data?: UserCommission }> = ({ data }) => {
    const { total_reward = 0, user_count = 0, rate = 0 } = data || {};
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="mt-[20px]">
            <div
                className="invite-top-card-gradient-border"
                style={{ height: `calc(calc(100vw - 2rem) / 2.5109489051)` }}
            >
                <div className="flex justify-center text-body3 text-text_1 py-2 mx-[12px]">
                    <Trans
                        defaults={"current_rebate_ratio"}
                        values={{ num: `${rate}%` }}
                        components={{
                            span: (
                                <span className="text-text_brand font-semibold indent-1" />
                            ),
                        }}
                    />
                </div>
                <div className="flex items-center justify-between py-2">
                    <div className="flex-1 flex flex-col items-center">
                        <div className="text-direction2 text-brand_1 rounded-[12px] bg-AlphaOrange dark:bg-DarkAlphaOrange px-1.5 py-1"> 
                            +{formatPrice(data?.up_reward)}
                        </div>
                        <div className="text-h3 font-Semibold text-brand_1 my-1">
                            {formatPrice(total_reward)}
                        </div>
                        <div
                            className="flex bg-button_brand rounded-[24px] px-1.5 w-[100px] h-6 cursor-pointer items-center justify-center"
                            onClick={() => {
                                navigate("/rebate-withdraw");
                            }}
                        >
                            <span className="text-white text-direction2 font-semibold ">
                                {t("withdraw")}
                            </span>
                        </div>
                    </div>
                    <div className="flex-1 flex flex-col items-center">
                        <div className="text-direction2 text-brand_1 rounded-[12px] bg-AlphaOrange dark:bg-DarkAlphaOrange px-1.5 py-1"> 
                            +{data?.up_users || 0}
                        </div>
                        <div className="text-h3 font-Semibold text-brand_1 my-1">
                            {user_count}
                        </div>
                        <div className="text-direction1 font-semibold text-text_1 h-6 flex items-center">
                            {t("invite_friend")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InviteCard;
